import React from 'react';
import AddRounded from '@mui/icons-material/AddRounded';
import { useGridApiContext, useGridSelector, gridFilteredTopLevelRowCountSelector } from '@mui/x-data-grid-pro';
import ActiveFilterChips from './ActiveFilterChips';

// New UI for reports (docs/ui_redesign/14-screen-concepts.md, "Reports", option A): the report's own choices
// (company, module) and its active filters in a settings bar above the table, with the row count. The controls are
// the report's own elements, moved here; "Add filter" opens the grid's own filter panel, as the Filters button does.
function Param({ label, children }) {
	return <div className="apw2-param">{label ? <span className="apw2-param-l">{label}</span> : null}{children}</div>;
}

export default function ParamsBar({ customcomponent, labels = [] }) {
	const apiRef = useGridApiContext();
	const count = useGridSelector(apiRef, gridFilteredTopLevelRowCountSelector);
	const parts = customcomponent && customcomponent.type === React.Fragment ? React.Children.toArray(customcomponent.props.children) : (customcomponent ? [customcomponent] : []);
	return (
		<div className="apw2-params" role="group" aria-label="Report settings">
			{parts.map((el, i) => <Param key={i} label={labels[i]}>{el}</Param>)}
			<Param label="Filters">
				<div className="apw2-param-filters">
					<ActiveFilterChips inline />
					<button type="button" className="apw2-linkbtn apw2-addfilter" onClick={() => apiRef.current.showFilterPanel()}><AddRounded fontSize="inherit" />Add filter</button>
				</div>
			</Param>
			<span className="apw2-grow" />
			<span className="apw2-params-count" aria-live="polite">{count} {count === 1 ? 'row' : 'rows'}</span>
		</div>
	);
}
